<template>
  <div>{{ $t('404.title') }}</div>
</template>

<script>
export default {
  name: 'NotFound',
};
</script>
